import React, { useState, useEffect } from "react";
import axios from "axios";

const BusSchedule = () => {
  const sessionId = localStorage.getItem("currentSessionId");

  const [formData, setFormData] = useState({
    busNumber: "",
    route: "",
    departureTime: "",
    arrivalTime: "",
    driverName: "",
    contactNumber: "",
    studentCapacity: "",
  });

  const [schedules, setSchedules] = useState([]);
  const [editId, setEditId] = useState(null);
  const [busNumbers, setBusNumbers] = useState([]);
  const [routes, setRoutes] = useState([]);

  // Fetch bus numbers
  useEffect(() => {
    if (!sessionId) return;

    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/busDetails/getAllBusDetails?sessionId=${sessionId}`)
      .then((res) => setBusNumbers(res.data))
      .catch((err) => console.error(err));
  }, [sessionId]);

  // Fetch routes
  useEffect(() => {
    if (!sessionId) return;

    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/busroutes/getBusRoutes?sessionId=${sessionId}`)
      .then((res) => setRoutes(res.data))
      .catch((err) => console.error(err));
  }, [sessionId]);

  // Fetch schedules
  useEffect(() => {
    fetchSchedules();
  }, [sessionId]);

  const fetchSchedules = () => {
    if (!sessionId) return;

    axios
      .get(` ${process.env.REACT_APP_API_BASE_URL}/api/busSchedules?session=${sessionId}`)
      .then((res) => setSchedules(res.data))
      .catch((err) => console.error(err));
  };

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData((prev) => ({ ...prev, [name]: value }));
  };

  const handleBusNumberChange = (e) => {
    const selectedBusNumber = e.target.value;
    const selectedBus = busNumbers.find((bus) => bus.busNumber === selectedBusNumber);

    if (selectedBus) {
      setFormData((prev) => ({
        ...prev,
        busNumber: selectedBus.busNumber,
        driverName: selectedBus.driver,
        contactNumber: selectedBus.driverMobNumber,
        studentCapacity: selectedBus.studentCapacity,
      }));
    }
  };

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = { ...formData, session: sessionId };

    if (editId) {
      axios
        .put(` ${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/updateBusSchedule/${editId}`, payload,
          {
            headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
          }
        )
        .then(() => {
          resetForm();
          fetchSchedules();
          alert("Bus Schedule Updated");
        })
        .catch((err) => console.error(err));
    } else {
      axios
        .post(`${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/createBusSchedule`, payload,{
          headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
        })
        .then(() => {
          resetForm();
          fetchSchedules();
          alert("Bus Schedule Added");
        })
        .catch((err) => console.error(err));
    }
  };

  const resetForm = () => {
    setFormData({
      busNumber: "",
      route: "",
      departureTime: "",
      arrivalTime: "",
      driverName: "",
      contactNumber: "",
      studentCapacity: "",
    });
    setEditId(null);
  };

  const handleEdit = (schedule) => {
    setFormData({
      busNumber: schedule.busNumber,
      route: schedule.route,
      departureTime: schedule.departureTime,
      arrivalTime: schedule.arrivalTime,
      driverName: schedule.driverName,
      contactNumber: schedule.contactNumber,
      studentCapacity: schedule.studentCapacity,
    });
    setEditId(schedule._id);
  };

  const handleDelete = (id) => {
    if (!window.confirm("Are you sure you want to delete this bus schedule?")) return;

    axios
      .delete(` ${process.env.REACT_APP_API_BASE_URL}/api/busSchedules/deleteBusSchedule/${id}?session=${sessionId}`,{
        headers: { Authorization: `Bearer ${localStorage.getItem("token")}` }
      })
      .then(() => fetchSchedules())
      .catch((err) => console.error(err));
  };

  return (
    <div className="container mx-auto p-4">
      {/* FORM */}
      <form onSubmit={handleSubmit} className="mb-6">
        {/* Bus Number */}
        <div className="mb-4">
          <label className="block text-gray-700">Bus Number</label>
          <select
            name="busNumber"
            value={formData.busNumber}
            onChange={handleBusNumberChange}
            className="border p-2 w-full"
            required
          >
            <option value="">Select Bus Number</option>
            {busNumbers.map((bus) => (
              <option key={bus.busNumber} value={bus.busNumber}>
                {bus.busNumber}
              </option>
            ))}
          </select>
        </div>

        {/* Route */}
        <div className="mb-4">
          <label className="block text-gray-700">Route</label>
          <select
            name="route"
            value={formData.route}
            onChange={handleChange}
            className="border p-2 w-full"
            required
          >
            <option value="">Select Bus Route</option>
            {routes.map((route) => (
              <option key={route.routeName} value={route.routeName}>
                {route.routeName}
              </option>
            ))}
          </select>
        </div>

        {/* Arrival & Departure */}
        <div className="mb-4">
          <label className="block text-gray-700">Arrival Time</label>
          <input
            type="time"
            name="arrivalTime"
            value={formData.arrivalTime}
            onChange={handleChange}
            className="border p-2 w-full"
            required
          />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Departure Time</label>
          <input
            type="time"
            name="departureTime"
            value={formData.departureTime}
            onChange={handleChange}
            className="border p-2 w-full"
            required
          />
        </div>

        {/* Driver, Contact & Capacity */}
        <div className="mb-4">
          <label className="block text-gray-700">Driver Name</label>
          <input type="text" name="driverName" value={formData.driverName} className="border p-2 w-full" disabled />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Contact Number</label>
          <input type="number" name="contactNumber" value={formData.contactNumber} className="border p-2 w-full" disabled />
        </div>

        <div className="mb-4">
          <label className="block text-gray-700">Student Capacity</label>
          <input type="number" name="studentCapacity" value={formData.studentCapacity} className="border p-2 w-full" disabled />
        </div>

        <button className="bg-blue-800 text-white p-2 rounded">
          {editId ? "Update Schedule" : "Add Schedule"}
        </button>
      </form>

      {/* TABLE */}
      <h2 className="text-xl font-bold mb-4">Bus Schedules</h2>
      <table className="min-w-full border border-gray-300">
        <thead>
          <tr>
            <th className="border p-2">Sr.</th>
            <th className="border p-2">Bus</th>
            <th className="border p-2">Route</th>
            <th className="border p-2">Arrival</th>
            <th className="border p-2">Departure</th>
            <th className="border p-2">Driver</th>
            <th className="border p-2">Contact</th>
            <th className="border p-2">Capacity</th>
            <th className="border p-2">Actions</th>
          </tr>
        </thead>
        <tbody className="text-center">
          {schedules.map((schedule, index) => (
            <tr key={schedule._id}>
              <td className="border p-2">{index + 1}</td>
              <td className="border p-2">{schedule.busNumber}</td>
              <td className="border p-2">{schedule.route}</td>
              <td className="border p-2">{schedule.arrivalTime}</td>
              <td className="border p-2">{schedule.departureTime}</td>
              <td className="border p-2">{schedule.driverName}</td>
              <td className="border p-2">{schedule.contactNumber}</td>
              <td className="border p-2">{schedule.studentCapacity}</td>
              <td className="border p-2">
                <button onClick={() => handleEdit(schedule)} className="bg-yellow-500 text-white px-2 mr-2">Edit</button>
                <button onClick={() => handleDelete(schedule._id)} className="bg-red-500 text-white px-2">Delete</button>
              </td>
            </tr>
          ))}
        </tbody>
      </table>
    </div>
  );
};

export default BusSchedule;
